import { hasReach } from '../common/utils';
const { debounce } = window.FEGOUtils;
import { ref, onMounted, onBeforeUnmount, nextTick, unref } from 'vue-demi';

export default (swiper, el) => {
    const isInViewport = ref(false);

    const onScroll = debounce(() => {
        const $el = unref(el);
        isInViewport.value = hasReach($el);
        // 如果到达视口了，开始轮播、停止监听滚动事件
        if (isInViewport.value) {
            swiper.value?.autoplay.start();
            window.removeEventListener('scroll', onScroll);
        }
    });

    onMounted(() => {
        const $el = unref(el);
        isInViewport.value = hasReach($el);
        // 如果不在视口内
        if (!isInViewport.value) {
            // 监听滚动事件
            window.addEventListener('scroll', onScroll);
            // 停止自动播放
            nextTick(() => {
                swiper.value?.autoplay.stop();
            });
        }
    });

    // 组件销毁时，移除监听
    onBeforeUnmount(() => {
        window.removeEventListener('scroll', onScroll);
    });
};
